import { CreateCandidateSalaryClass } from './create-candidate-job-offer-salary.model';
import { CreateCandidateJobOfferClass } from './create-candidate-job-information.model';


export class CreateCandidateJobInformationClass {
    jobOffer?: CreateCandidateJobOfferClass;
    salary?: CreateCandidateSalaryClass;
}
